export var ChartTypes = /*#__PURE__*/function (ChartTypes) {
  ChartTypes["LINE"] = "line";
  ChartTypes["BAR"] = "bar";
  return ChartTypes;
}({});
export var ChartStateTypes = /*#__PURE__*/function (ChartStateTypes) {
  ChartStateTypes[ChartStateTypes["ERROR"] = 0] = "ERROR";
  ChartStateTypes[ChartStateTypes["LOADING"] = 1] = "LOADING";
  ChartStateTypes[ChartStateTypes["SUCCESS"] = 2] = "SUCCESS";
  ChartStateTypes[ChartStateTypes["EMPTY"] = 3] = "EMPTY";
  return ChartStateTypes;
}({});